import { gsap } from "gsap";

export const animateSwipe = () => {
    const tlHand = gsap.timeline({
        duration: 4,
        delay: 0,
        repeat: -1,
        // ease: "sine.inOut",
        transformOrigin: "bottom center",
    });
    tlHand.to(
        "#swipe_hand",
        {
            duration: 1,
            opacity: 1,
            rotation: 10,
        }
    );
    tlHand.to(
        "#swipe_hand",
        {
            duration: 1,
            opacity: 1,
            rotation: 10,
        }
    );
    tlHand.to(
        "#swipe_hand",
        {
            duration: 1,
            opacity: 0.5,
            rotation: 0,
        }
    );

    const tlArrow = gsap.timeline({
        duration: 4,
        delay: 0,
        repeat: -1,
        ease: "sine.inOut",
    });
    tlArrow.to(
        "#swipe_arrow",
        {
            opacity: 0.1,
        },
        {
            opacity: 1,
        },
    );
    return [tlHand, tlArrow];
}

export const animatePoint = () => {
    const tlHand = gsap.timeline({
        delay: 0,
        repeat: -1,
        ease: "sine.inOut",
        transformOrigin: "bottom center"
    });
    tlHand.to(
        "#point_hand",
        {
            duration: 1,
            x: 10,
            y: 20,
            opacity: 0.5,
        }
    );
    tlHand.to(
        "#point_hand",
        {
            duration: 1,
            x: 10,
            y: 20,
            opacity: 1,
        }
    )
    tlHand.to(
        "#point_hand",
        {
            duration: 1,
            x: 0,
            y: 0,
            opacity: 1,
        }
    );
    tlHand.to(
        "#point_hand",
        {
            duration: 1,
            x: 0,
            y: 0,
            opacity: 1,
        }
    );


    const tlRing = gsap.timeline({
        delay: 0.25,
        repeat: -1,
        ease: "sine.inOut",
    });
    tlRing.to(
        "#point_ring",
        {
            duration: 3,
            opacity: 0.25,
        }
    );
    tlRing.to(
        "#point_ring",
        {
            duration: 5,
            opacity: 1,
        },
    )
    return [tlHand, tlRing]
}